import { TooltipCode } from 'areas/shared/consts';

const DeclarationForm = {
    code: "DeclarationForm",
    description: "Declaration Form",
    notApplicableLabel: "Not applicable to my Business",
    tooltipCode: TooltipCode.COMPANY.DECFORM
};

export default {
    DeclarationForm
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/companyInfo/UploadsConfig.js